const messages = {
  name: 'Application |||| Applications',
  fields: {
    name: 'Application Name',
  },
  empty: 'No applications yet',
  invite: 'Add your first application',
  create: {
    title: 'Create Application',
  },
  edit: {
    title: 'Edit Application',
  },
  dialog: {
    title: 'Application Details',
  },
  sections: {
    basicInfo: 'Basic Information',
  },
  columns: {
    actions: 'Actions',
  },
  filters: {
    applicationName: 'Application Name',
  },
  actions: {
    addApplication: 'Add Application',
    discard: 'Discard',
    submit: 'Submit',
  },
  validation: {
    nameRequired: 'Application Name is required',
    nameMaxLength: 'Application Name must be at most %{max} characters',
  },
  help: {
    createBanner: 'Add a new application to your Notify account.',
    editBanner: 'Update the application details.',
    name: 'The display name for this application. Must be unique.',
  },
  delete: {
    title: 'Delete application "%{recordName}"',
    content: 'Are you sure you want to delete this application? This action cannot be undone.',
  },
  notifications: {
    created: 'Application created successfully',
    updated: 'Application updated successfully',
    deleted: 'Application deleted successfully',
    loadFailed: 'Failed to load application',
    createFailed: 'Failed to create application',
    updateFailed: 'Failed to update application',
  },
};

export default messages;
